import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { v4 as uuidv4 } from '@shared/util/uuid';
import { GenericComponent } from '../../config';
import { BasicFieldOption } from './BasicFieldOption';
import { FieldOption } from './FieldOption';

export class DateRangeFieldOption implements FieldOption {
  public missingDependencies: FieldOption[] = [];

  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<GenericComponent>,
  ) {}

  matchesComponent(component: API.AnyComponent): boolean {
    return this.component.type === component.type;
  }

  canBeAdded(_components: API.AnyComponent[]): boolean {
    return true;
  }

  updateMissingDependencies(_components: API.AnyComponent[]) {
    // Generate ID for the DateRange component itself if it doesn't exist
    if (!this.component.id) {
      this.component.id = uuidv4();
    }

    const startDateComponentId = uuidv4();
    const endDateComponentId = uuidv4();
    (this.component as Partial<API.DateRangeComponent>).startDateComponentId = startDateComponentId;
    (this.component as Partial<API.DateRangeComponent>).endDateComponentId = endDateComponentId;

    const dateRangeComponent = this.component as Partial<API.DateRangeComponent>;
    const defaultLabel = i18n('card.blocks.dateRangeInput.defaultLabel');
    const startSuffix = i18n('card.blocks.dateRangeInput.startSuffix');
    const endSuffix = i18n('card.blocks.dateRangeInput.endSuffix');
    const parentLabel = dateRangeComponent.label || defaultLabel;
    const parentPlaceholder = dateRangeComponent.placeholder || parentLabel;

    this.missingDependencies = [
      new BasicFieldOption(i18n('card.blocks.dateRangeInput.startDateLabel'), 'calendar', {
        type: 'DATE',
        id: startDateComponentId,
        label: `${parentLabel}: ${startSuffix}`,
        placeholder: `${parentPlaceholder}: ${startSuffix}`,
        icon: 'calendar',
        managedByComponentId: this.component.id,
      }),
      new BasicFieldOption(i18n('card.blocks.dateRangeInput.endDateLabel'), 'calendar', {
        type: 'DATE',
        id: endDateComponentId,
        label: `${parentLabel}: ${endSuffix}`,
        placeholder: `${parentPlaceholder}: ${endSuffix}`,
        icon: 'calendar',
        managedByComponentId: this.component.id,
      }),
    ];
  }
}
